/** Inline LOA preview for the agent review Artefacts step. */

import { LoaDocumentPreview } from "@/components/pdf/loa/LoaDocumentPreview";
import type { ArtefactReviewItem } from "./types";

interface LoaArtefactPreviewProps {
  artefact: ArtefactReviewItem;
  className?: string;
}

export function LoaArtefactPreview({ artefact, className }: LoaArtefactPreviewProps) {
  return (
    <LoaDocumentPreview
      templateKey={artefact.template_key ?? undefined}
      formData={artefact.form_data ?? {}}
      className={className}
      testId="loa-artefact-preview"
    />
  );
}
